import { AsyncThunkAction } from 'actions/actions.types'
import { isChangeProfileItemAction } from 'actions/datingProfileAction'
import { toggleProfileUpdateAction } from 'actions/profile/toggleProfileUpdateAction'
import { fetchUniNoticeAction } from 'actions/uninotice/uniNoticeAction'
import { cascadeChangeProfileCompletedType } from 'components/presentational/Notifications/NotificationType'

import { fetchCurrentAuthorizedProfileSharingAvailableAction } from '../sharingContent/fetchCurrentAuthorizedProfileSharingAvailableAction'

/**
 * Экшен завершения заполнения профиля.
 */
export const profileDataCompletedAction =
  (): AsyncThunkAction => (dispatch) => {
    dispatch(fetchUniNoticeAction(cascadeChangeProfileCompletedType))
    dispatch(isChangeProfileItemAction(false))
    dispatch(toggleProfileUpdateAction(true))
  }

export const CLEAR_CURRENT_PROFILE_SHARING =
  'CLEAR_CURRENT_PROFILE_SHARING' as const

export const clearMyProfileSharingAction = () => ({
  type: CLEAR_CURRENT_PROFILE_SHARING,
})

export type FetchMyProfileSharingAvailableTypes =
  | ReturnType<typeof fetchCurrentAuthorizedProfileSharingAvailableAction>
  | ReturnType<typeof clearMyProfileSharingAction>
